import { ILayer } from '../layer.type';
import { environment } from '../../../../../environments/environment';
import { _ } from '../../../utils';
import { generateDigitrafficTimeParam, getSharedLayer } from './shared';

const ZOOM_LEVEL_EQUIPMENT = 15;

/** Already translated */
const VrLayerGroupNames = {
  TRAINS: _('Trains'),
  EQUIPMENT: _('Equipment'),
  RAIL_INFRASTRUCTURE: _('Rail infrastructure')
} as const;

/**
 * VRGroup layers
 */
export default function getLayers(): ILayer[] {
  const timeParam = encodeURIComponent(generateDigitrafficTimeParam());
  return [
    {
      id: 'Kaukojunat',
      name: _('Long-distance'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 14km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        priority: 10,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true
    },
    {
      id: 'Lähijunat',
      name: _('Commuter'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 12 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        priority: 5,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true
    },
    {
      id: 'Muut',
      name: _('Others'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true
    },
    {
      id: 'TR',
      name: _('TR'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true,
    },
    {
      id: 'TL',
      name: _('TL'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true,
    },
    {
      id: 'TA',
      name: _('TA'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true,
    },
    {
      id: 'T',
      name: _('T'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group:VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
      useWorker: true,
    },
    {
      id: 'Veturit',
      name: _('Locomotive'),
      title: 'Junat',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: true
      },
      metadata: {
        group: VrLayerGroupNames.TRAINS,
        component: 'TrainInfoComponent',
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['tripNumber', 'category', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: 10 // === 2km
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'tripNumber', type: 'startsWith' },
          { key: 'category', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'equipment', type: 'equals', reason: _('attached locomotive matches'), priority: -1 }
        ],
      },
    },
    {
      id: 'SR1',
      name: _('SR1'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SR2',
      name: _('SR2'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SR3',
      name: _('SR3'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'DV12',
      name: _('DV12'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'DR14',
      name: _('DR14'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'DR16',
      name: _('DR16'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'DM12',
      name: _('DM12'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SM2',
      name: _('SM2'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SM3',
      name: _('SM3'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SM4',
      name: _('SM4'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SM5',
      name: _('SM5'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    {
      id: 'SM6',
      name: _('SM6'),
      title: 'Kalusto',
      source: 'trains',
      asMarkers: true,
      selectable: true,
      style: {
        layerType: 'html-marker',
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.EQUIPMENT,
        hoverComponent: 'TrainHover',
        hoverProperties: {
          coordinates: false,
          properties: ['equipment', 'title', 'label']
        },
        uniqueBy: '_id',
        labelBy: 'label',
        detailsComponent: 'train-details',
        zoomLevel: ZOOM_LEVEL_EQUIPMENT
      },
      searchOptions: {
        searchable: true,
        minimumSearchTermLength: 3,
        interestingProperties: [
          { key: 'equipment', type: 'startsWith' },
          { key: 'title', type: 'startsWith' },
          { key: 'label', type: 'startsWith' },
          { key: 'subTitle', type: 'startsWith' }
        ],
      },
      useWorker: true,
    },
    getSharedLayer('levelcrossings'),
    getSharedLayer('rails'),
    getSharedLayer('trafficControlPoints'),
    getSharedLayer('intersectionStations'),
    {
      id: 'Ratapihat',
      name: _('Railyards'),
      geojsonURL: environment.assetRoot + '/data/vr/ratapihat.geojson',
      selectable: false,

      style: {
        layerType: 'symbol',
        sourceType: 'geojson',
        clickable: true,
        icon: { url: environment.assetRoot + '/data/vr/ratapiha.png' },
        visible: false
      },
      metadata: {
        group: VrLayerGroupNames.RAIL_INFRASTRUCTURE,
        component: 'ElementDetailsComponent',
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['name']
        },
        uniqueBy: 'name',
        labelBy: 'name',
        url: 'https://kalustopaikannus.vr.fi/ratapihanakyma/',
        urlProperty: 'name',
        urlDescription: _('Open equipment positioning for railyard')
      },
      searchOptions: {
        searchable: false,
        minimumSearchTermLength: 1,
        interestingProperties: [
          { key: 'name', type: 'contains' }
        ],
      },
      useWorker: true,
      orderingWeight: -1,
    },
    {
      id: 'Kuumakäynti-ilmaisimet',
      name: _('Hot-box detectors'),
      selectable: true,
      geojsonURL: `https://rata.digitraffic.fi/infra-api/0.2/elementit.geojson?srsName=crs%3A84&time=${timeParam}&typeNames=kuumakayntiilmaisin`,
      metadata: {
        group: VrLayerGroupNames.RAIL_INFRASTRUCTURE,
        component: 'ElementDetailsComponent',
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['nimi', 'tunniste', 'tyyppi']
        },
        uniqueBy: 'tunniste',
        labelBy: 'nimi',
      },
      searchOptions: {
        searchable: false,
        minimumSearchTermLength: 2,
        interestingProperties: [
          { key: 'nimi', type: 'contains' },
          { key: 'tunniste', type: 'contains' },
          { key: 'tyyppi', type: 'contains' }
        ],
      },
      style: {
        layerType: 'symbol',
        sourceType: 'geojson',
        clickable: true,
        visible: false,
        icon: { url: environment.assetRoot + '/data/vr/kuumakaynti.png' },
      },
      useWorker: true,
    },
    {
      id: 'KM markers',
      name: _('KM markers'),
      vectorURL: 'mapbox://mipro-dev.4ssmf4wd',
      vectorSourceLayer: 'kilometrimerkit_4326-8u84ds',
      orderingWeight: 1000,
      mapboxOptions: {
        paint: {
          'text-color': 'black',
          'text-halo-color': 'hsl(35, 8%, 85%)',
          'text-halo-width': 0.5,
        },
        layout: {
          'icon-image': 'house_number_plate',
          'icon-size': 0.85,
          'icon-offset': [15, 0],
          'text-field': ['get', 'ratakm'],
          'text-font': ['Arial Unicode MS Regular'],
          'text-max-width': 7,
          'text-padding': 4,
          'text-size': 11,
          'text-offset': [1.0, 0.0]
        },
      },
      metadata: {
        group: VrLayerGroupNames.RAIL_INFRASTRUCTURE,
        labelBy: 'ratakm',
        uniqueBy: 'tunniste',
        visibleByZoom: 10,
        //component: 'ElementDetailsComponent',
        //hoverComponent: 'ElementDetailsHover',
        //hoverProperties: {
        //  coordinates: false,
        //  properties: ['ratakm', 'pituus', 'ratanumero', 'rata', 'tunniste', 'seuraavaKilometrimerkki']
        //},
      },
      searchOptions: {
        searchable: false
      },
      style: {
        sourceType: 'vector',
        layerType: 'symbol',
        //clickable: true,
        visible: true,
        icon: {
          url: environment.assetRoot + '/img/house_number_plate.png',
        },
      },
    },
    {
      id: 'Pyörävoimailmaisin',
      name: _('Wheel strength indicator'),
      geojsonURL: `https://rata.digitraffic.fi/infra-api/0.2/elementit.geojson?srsName=crs%3A84&time=${timeParam}&typeNames=pyoravoimailmaisin`,
      metadata: {
        group: VrLayerGroupNames.RAIL_INFRASTRUCTURE,
        component: 'ElementDetailsComponent',
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['nimi', 'tunniste', 'tyyppi']
        },
        uniqueBy: 'tunniste',
        labelBy: 'nimi',
      },
      searchOptions: {
        searchable: false,
        minimumSearchTermLength: 2,
        interestingProperties: [
          { key: 'nimi', type: 'contains' },
          { key: 'tunniste', type: 'contains' },
          { key: 'tyyppi', type: 'contains' }
        ],
      },
      style: {
        layerType: 'symbol',
        sourceType: 'geojson',
        clickable: true,
        visible: false,
        icon: { url: environment.assetRoot + '/data/vr/pyoravoima.png' },
      },
      useWorker: true,
    },
    {
      id: 'Virroitinvalvontakamera',
      name: _('Impulse control camera'),
      geojsonURL: `https://rata.digitraffic.fi/infra-api/0.2/elementit.geojson?srsName=crs%3A84&time=${timeParam}&typeNames=virroitinvalvontakamera`,
      metadata: {
        group: VrLayerGroupNames.RAIL_INFRASTRUCTURE,
        component: 'ElementDetailsComponent',
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['nimi', 'tunniste', 'tyyppi']
        },
        uniqueBy: 'tunniste',
        labelBy: 'nimi',
      },
      searchOptions: {
        searchable: false,
        minimumSearchTermLength: 2,
        interestingProperties: [
          { key: 'nimi', type: 'contains' },
          { key: 'tunniste', type: 'contains' },
          { key: 'tyyppi', type: 'contains' }
        ],
      },
      style: {
        layerType: 'symbol',
        sourceType: 'geojson',
        clickable: true,
        visible: false,
        icon: { url: environment.assetRoot + '/data/vr/virroitinvalvonta.png' },
      },
      useWorker: true,
    }
  ];
}
